import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=7a349432&scoped=true&"
import script from "./DashboardComponent.vue?vue&type=script&lang=js&"
export * from "./DashboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComponent.vue?vue&type=style&index=0&id=7a349432&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a349432",
  null
  
)

export default component.exports